import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PROGRAMAS = [
  {
    tipo: 'militar',
    icono: '🎖️',
    titulo: 'Inglés Militar',
    subtitulo: 'Programa SLP',
    niveles: [
      { id: 'SLP2', label: 'SLP 2' },
      { id: 'SLP3', label: 'SLP 3' },
      { id: 'SLP4', label: 'SLP 4' },
      { id: 'ACCESO_SUBOFICIAL', label: 'Acceso Suboficial' },
      { id: 'ACCESO_OFICIAL', label: 'Acceso Oficial' },
      { id: 'CURSO_SUBOFICIAL', label: 'Curso Suboficial' },
      { id: 'CURSO_OFICIAL', label: 'Curso Oficial' },
    ],
    color: '#EC4899',
    bg: '#FFF0F5',
    border: '#FBCFE8',
  },
  {
    tipo: 'civil',
    icono: '🎓',
    titulo: 'Inglés Civil',
    subtitulo: 'Cambridge',
    niveles: [
      { id: 'B1', label: 'B1' },
      { id: 'B2', label: 'B2' },
      { id: 'C1', label: 'C1' },
      { id: 'C2', label: 'C2' },
    ],
    color: '#8B5CF6',
    bg: '#F5F3FF',
    border: '#DDD6FE',
  },
];

const inputStyle = {
  width: '100%', padding: '12px 16px', borderRadius: '10px',
  background: '#FFF0F5', border: '1px solid #FBCFE8', color: '#581C47',
  fontSize: '15px', outline: 'none', boxSizing: 'border-box',
};
const labelStyle = {
  display: 'block', color: '#EC4899', fontSize: '13px',
  marginBottom: '6px', fontWeight: 600,
};

export default function Login() {
  const { login, registrar, loginCodigo } = useAuth();
  const navigate = useNavigate();
  const [modo, setModo] = useState('login'); // 'login' | 'registro' | 'codigo'
  const [paso, setPaso] = useState(1); // 1 = datos, 2 = programa+nivel
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  // Login
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });

  // Registro paso 1
  const [regForm, setRegForm] = useState({
    nombre: '', apellidos: '', email: '', password: '', passwordRep: '', telefono: '',
  });
  // Registro paso 2
  const [tipoSel, setTipoSel] = useState(null);
  const [nivelSel, setNivelSel] = useState(null);

  // Flujo código de acceso
  const [codigoVal, setCodigoVal] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);
    try {
      const u = await login(loginForm.email, loginForm.password);
      if (u.rol === 'admin') navigate('/admin');
      else if (u.rol === 'profesor') navigate('/seleccion');
      else if (u.suscripcion_activa) navigate('/seleccion');
      else navigate('/pagar');
    } catch (err) {
      setError(err.response?.data?.error || 'Credenciales incorrectas');
    } finally { setCargando(false); }
  };

  const validarPaso1 = () => {
    if (!regForm.nombre.trim()) return 'El nombre es obligatorio';
    if (!regForm.apellidos.trim()) return 'Los apellidos son obligatorios';
    const emailCompleto = regForm.email.trim().toLowerCase();
    if (!emailCompleto) return 'El correo es obligatorio';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailCompleto)) return 'El correo no tiene un formato válido';
    if (!regForm.password) return 'La contraseña es obligatoria';
    if (regForm.password.length < 6) return 'La contraseña debe tener al menos 6 caracteres';
    if (regForm.password !== regForm.passwordRep) return 'Las contraseñas no coinciden';
    if (!regForm.telefono.trim()) return 'El teléfono es obligatorio';
    return null;
  };

  const siguientePaso = () => {
    const err = validarPaso1();
    if (err) { setError(err); return; }
    setError('');
    setPaso(2);
  };

  const handleRegistro = async () => {
    if (!tipoSel || !nivelSel) { setError('Selecciona programa y nivel'); return; }
    setError('');
    setCargando(true);
    try {
      const nombreCompleto = `${regForm.nombre.trim()} ${regForm.apellidos.trim()}`;
      await registrar({
        nombre: nombreCompleto,
        email: regForm.email.trim().toLowerCase(),
        password: regForm.password,
        telefono: regForm.telefono.trim(),
        tipo: tipoSel,
        nivel: nivelSel,
      });
      navigate('/pagar');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al crear la cuenta');
    } finally { setCargando(false); }
  };

  const cambiaModo = (m) => {
    setModo(m); setError(''); setPaso(1);
    setTipoSel(null); setNivelSel(null);
    setCodigoVal('');
  };

  const programaSel = PROGRAMAS.find(p => p.tipo === tipoSel);

  // ── Flujo código ──────────────────────────────────────────────────────────

  const handleLoginCodigo = async (e) => {
    e.preventDefault();
    if (!codigoVal.trim()) return setError('Introduce el código de acceso');
    setError(''); setCargando(true);
    try {
      await loginCodigo(codigoVal.trim());
      navigate('/seleccion');
    } catch (err) {
      setError(err.response?.data?.error || 'Código no válido');
    } finally { setCargando(false); }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #FCE7F3 0%, #F9A8D4 50%, #D8B4FE 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: 'url(/united.png)',
        backgroundSize: 'cover', backgroundPosition: 'center',
        opacity: 0.12,
        filter: 'grayscale(100%) sepia(100%) hue-rotate(290deg) saturate(3) brightness(1.8)',
        pointerEvents: 'none',
      }} />

      <div className="fade-in" style={{
        background: '#FFFFFF', border: '1px solid #FBCFE8', borderRadius: '20px',
        padding: '40px 36px', width: '100%',
        maxWidth: modo === 'registro' && paso === 2 ? '560px' : '440px',
        boxShadow: '0 24px 64px rgba(236,72,153,0.12)',
        position: 'relative', zIndex: 1, transition: 'max-width 0.3s ease',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <h1 style={{
            fontSize: '34px', fontWeight: 800, marginBottom: '4px',
            background: 'linear-gradient(135deg, #831843 0%, #EC4899 55%, #A855F7 100%)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
          }}>Su Academia</h1>
          <p style={{ color: '#EC4899', fontSize: '14px', fontWeight: 500, letterSpacing: '1px' }}>Campus Virtual</p>
        </div>

        {/* Tabs */}
        <div style={{ display: 'flex', background: '#FFF0F5', borderRadius: '12px', padding: '4px', marginBottom: '28px' }}>
          {[{ id: 'login', label: 'Iniciar sesión' }, { id: 'registro', label: 'Crear cuenta' }, { id: 'codigo', label: 'Código de acceso' }].map(t => (
            <button key={t.id} onClick={() => cambiaModo(t.id)}
              style={{
                flex: 1, padding: '9px', borderRadius: '9px', border: 'none', cursor: 'pointer', fontSize: '13px',
                fontWeight: modo === t.id ? 700 : 400,
                background: modo === t.id ? 'linear-gradient(135deg, #EC4899 0%, #A855F7 100%)' : 'transparent',
                color: modo === t.id ? '#fff' : '#BE84A3',
                transition: 'all 0.2s',
                boxShadow: modo === t.id ? '0 4px 12px rgba(236,72,153,0.3)' : 'none',
              }}>
              {t.label}
            </button>
          ))}
        </div>

        {/* Error */}
        {error && (
          <div style={{ background: 'rgba(236,72,153,0.08)', border: '1px solid rgba(236,72,153,0.3)', borderRadius: '10px', padding: '11px 14px', color: '#DB2777', fontSize: '13px', marginBottom: '18px' }}>
            {error}
          </div>
        )}

        {/* ── LOGIN ─────────────────────────────── */}
        {modo === 'login' && (
          <form onSubmit={handleLogin}>
            {[
              { label: 'Correo electrónico', key: 'email', type: 'email', placeholder: '' },
              { label: 'Contraseña', key: 'password', type: 'password', placeholder: '' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: '18px' }}>
                <label style={labelStyle}>{f.label}</label>
                <input type={f.type} placeholder={f.placeholder}
                  value={loginForm[f.key]}
                  onChange={e => setLoginForm({ ...loginForm, [f.key]: e.target.value })}
                  required style={inputStyle} />
              </div>
            ))}
            <button type="submit" disabled={cargando} style={{
              width: '100%', padding: '13px', borderRadius: '50px',
              background: cargando ? '#FCE7F3' : 'linear-gradient(135deg, #EC4899 0%, #A855F7 100%)',
              border: 'none', color: cargando ? '#BE84A3' : '#fff',
              fontSize: '16px', fontWeight: 600, cursor: cargando ? 'not-allowed' : 'pointer',
              boxShadow: cargando ? 'none' : '0 6px 20px rgba(236,72,153,0.35)', transition: 'all 0.2s',
            }}>
              {cargando ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>
        )}

        {/* ── REGISTRO PASO 1: Datos personales ── */}
        {modo === 'registro' && paso === 1 && (
          <div>
            <p style={{ color: '#BE84A3', fontSize: '13px', marginBottom: '20px', textAlign: 'center' }}>
              Paso 1 de 2 — Tus datos personales
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '14px' }}>
              <div>
                <label style={labelStyle}>Nombre *</label>
                <input style={inputStyle} value={regForm.nombre}
                  onChange={e => setRegForm({ ...regForm, nombre: e.target.value })}
                  placeholder="" autoFocus />
              </div>
              <div>
                <label style={labelStyle}>Apellidos *</label>
                <input style={inputStyle} value={regForm.apellidos}
                  onChange={e => setRegForm({ ...regForm, apellidos: e.target.value })}
                  placeholder="" />
              </div>
            </div>

            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Correo electrónico *</label>
              <div style={{ position: 'relative' }}>
                <input style={inputStyle} type="email" value={regForm.email}
                  onChange={e => setRegForm({ ...regForm, email: e.target.value })}
                  placeholder="" />
                {regForm.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(regForm.email.toLowerCase()) && (
                  <p style={{ color: '#F87171', fontSize: '11px', marginTop: '4px' }}>
                    Correo no válido
                  </p>
                )}
              </div>
            </div>

            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Teléfono *</label>
              <input style={inputStyle} type="tel" value={regForm.telefono}
                onChange={e => setRegForm({ ...regForm, telefono: e.target.value })}
                placeholder="" />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '22px' }}>
              <div>
                <label style={labelStyle}>Contraseña *</label>
                <input style={inputStyle} type="password" value={regForm.password}
                  onChange={e => setRegForm({ ...regForm, password: e.target.value })}
                  placeholder="" />
              </div>
              <div>
                <label style={labelStyle}>Repetir contraseña *</label>
                <input style={inputStyle} type="password" value={regForm.passwordRep}
                  onChange={e => setRegForm({ ...regForm, passwordRep: e.target.value })}
                  placeholder="" />
              </div>
            </div>

            <button onClick={siguientePaso} style={{
              width: '100%', padding: '13px', borderRadius: '50px',
              background: 'linear-gradient(135deg, #EC4899 0%, #A855F7 100%)',
              border: 'none', color: '#fff', fontSize: '16px', fontWeight: 600,
              cursor: 'pointer', boxShadow: '0 6px 20px rgba(236,72,153,0.35)',
            }}>
              Siguiente →
            </button>
          </div>
        )}

        {/* ── REGISTRO PASO 2: Selección programa ── */}
        {modo === 'registro' && paso === 2 && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '18px' }}>
              <button onClick={() => { setPaso(1); setError(''); }} style={{ background: 'none', border: 'none', color: '#BE84A3', cursor: 'pointer', fontSize: '20px', padding: '0 4px' }}>
                ←
              </button>
              <p style={{ color: '#BE84A3', fontSize: '13px' }}>
                Paso 2 de 2 — Selecciona tu programa de estudios
              </p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
              {PROGRAMAS.map(p => (
                <div key={p.tipo} onClick={() => { setTipoSel(p.tipo); setNivelSel(null); }}
                  style={{
                    border: `2px solid ${tipoSel === p.tipo ? p.color : p.border}`,
                    background: tipoSel === p.tipo ? p.bg : '#fff',
                    borderRadius: '14px', padding: '18px 14px', textAlign: 'center',
                    cursor: 'pointer', transition: 'all 0.15s',
                    boxShadow: tipoSel === p.tipo ? `0 4px 16px ${p.color}30` : 'none',
                  }}>
                  <div style={{ fontSize: '28px', marginBottom: '6px' }}>{p.icono}</div>
                  <p style={{ color: '#581C47', fontWeight: 700, fontSize: '14px', margin: 0 }}>{p.titulo}</p>
                  <p style={{ color: p.color, fontSize: '11px', fontWeight: 600, margin: '2px 0 0' }}>{p.subtitulo}</p>
                </div>
              ))}
            </div>

            {tipoSel && programaSel && (
              <div style={{ marginBottom: '22px' }}>
                <p style={{ color: '#BE84A3', fontSize: '12px', marginBottom: '10px', fontWeight: 600 }}>
                  NIVEL ({programaSel.titulo})
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
                  {programaSel.niveles.map(n => (
                    <button key={n.id} onClick={() => setNivelSel(n.id)}
                      style={{
                        border: `2px solid ${nivelSel === n.id ? programaSel.color : programaSel.border}`,
                        background: nivelSel === n.id ? programaSel.bg : '#fff',
                        color: nivelSel === n.id ? programaSel.color : '#581C47',
                        borderRadius: '10px', padding: '10px 6px', fontSize: '14px', fontWeight: 700,
                        cursor: 'pointer', transition: 'all 0.12s',
                      }}>
                      {n.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {tipoSel && nivelSel && (
              <div style={{ background: '#FFF0F5', border: '1px solid #FBCFE8', borderRadius: '10px', padding: '12px 16px', marginBottom: '18px' }}>
                <p style={{ color: '#581C47', fontSize: '13px', margin: 0 }}>
                  <strong>Plan seleccionado:</strong> {programaSel?.titulo} · Nivel {nivelSel}
                </p>
              </div>
            )}

            <button onClick={handleRegistro} disabled={cargando || !tipoSel || !nivelSel}
              style={{
                width: '100%', padding: '13px', borderRadius: '50px',
                background: (!tipoSel || !nivelSel || cargando) ? '#FCE7F3' : 'linear-gradient(135deg, #EC4899 0%, #A855F7 100%)',
                border: 'none', color: (!tipoSel || !nivelSel || cargando) ? '#BE84A3' : '#fff',
                fontSize: '16px', fontWeight: 600,
                cursor: (!tipoSel || !nivelSel || cargando) ? 'not-allowed' : 'pointer',
                boxShadow: (!tipoSel || !nivelSel || cargando) ? 'none' : '0 6px 20px rgba(236,72,153,0.35)',
              }}>
              {cargando ? 'Creando cuenta...' : '💳 Continuar al pago'}
            </button>
          </div>
        )}

        {/* ── CÓDIGO DE ACCESO ─────────────────────────────── */}
        {modo === 'codigo' && (
          <form onSubmit={handleLoginCodigo}>
            <p style={{ color: '#BE84A3', fontSize: '13px', marginBottom: '20px', textAlign: 'center' }}>
              Introduce el código que te ha proporcionado la academia
            </p>
            <div style={{ marginBottom: '24px' }}>
              <label style={labelStyle}>Código de acceso</label>
              <input
                style={{ ...inputStyle, textTransform: 'uppercase', letterSpacing: '6px', fontSize: '22px', textAlign: 'center', fontWeight: 700 }}
                value={codigoVal}
                onChange={e => setCodigoVal(e.target.value.toUpperCase())}
                placeholder="XXXXXXXX"
                maxLength={8}
                autoFocus
              />
            </div>
            <button type="submit" disabled={cargando || !codigoVal.trim()} style={{
              width: '100%', padding: '13px', borderRadius: '50px',
              background: (!codigoVal.trim() || cargando) ? '#FCE7F3' : 'linear-gradient(135deg, #EC4899 0%, #A855F7 100%)',
              border: 'none', color: (!codigoVal.trim() || cargando) ? '#BE84A3' : '#fff',
              fontSize: '16px', fontWeight: 600,
              cursor: (!codigoVal.trim() || cargando) ? 'not-allowed' : 'pointer',
              boxShadow: (!codigoVal.trim() || cargando) ? 'none' : '0 6px 20px rgba(236,72,153,0.35)',
            }}>
              {cargando ? 'Entrando...' : 'Entrar →'}
            </button>
          </form>
        )}

        <p style={{ color: '#BE84A3', fontSize: '11px', textAlign: 'center', marginTop: '20px' }}>
          ¿Problemas con tu cuenta?{' '}
          <a href="mailto:academiasu9@gmail.com" style={{ color: '#EC4899', textDecoration: 'underline' }}>
            Contacta con nosotros
          </a>
        </p>
      </div>
    </div>
  );
}
